import debug from 'debug';

import {
  IPixelCompleteRegistration,
  IPixelInitiateCheckout,
  IPixelSearch,
  IPixelViewContent,
} from './interfaces';

const log = debug('sunny:Pixel');
const fbq = global['fbq'];

/**
 * Pixel 이벤트 전송 함수
 *
 * @see {@link https://docs.google.com/spreadsheets/d/1XJ2-sOkp4IXiojAkX2SXXegTPHUU2iQxXrwRlTeeMa4/edit#gid=313110158&range=B2 규격}
 */
export const track = (
  eventName: string,
  data?: IPixelCompleteRegistration | IPixelViewContent | IPixelSearch | IPixelInitiateCheckout,
): void => {
  if (!fbq) {
    return;
  }

  log(eventName);
  if (window.ya__.runMode !== 'local') {
    fbq('trackCustom', eventName, data);
  }
};
